import { shuffleArray } from 'lib/utilityFunctions';

let curriculum = {};
let audioMap = {};

export const setCurriculum = (gc) => { curriculum = gc; };
export const setAudioMap = (am) => { audioMap = am; };

export const getCurriculum = () => curriculum;
export const getAudioMap = () => audioMap;

/**
 * Shuffles syllablesBank array for each item within standardItems array in curriculum,
 * since parser adds targetSyllable last
 * Function able to transform any other part of standardItems in case other changes needed
 * @param {Array} items - array of objects from standardItems in curriculum - separate for onboarding and standard
 * @returns {Array} - initial array with shuffled syllablesBank array
 */
export const transformCurriculumItems = (items) => items.map(item => ({
  ...item,
  syllablesBank: shuffleArray(item.syllablesBank),
}));
